import { userClient } from "@/lib/connect.client";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
    followUserWithClient,
    getUserFollowingInfoWithClient,
    listUserFollowersWithClient,
    listUserFollowingWithClient,
    unfollowUserWithClient,
} from "./users.base";
import { getUserById } from "./users.client";

export const user = createQueryKeys("user", {
  getUser: ({
    userId,
  }: {
    userId: string;
  }) => ({
    queryKey: ["user", userId],
    queryFn: () => getUserById({ identifier: { case: "userId", value: userId } }),
  }),
  getFollowingInfo: ({
    userId,
    viewerId,
  }: {
    userId: string;
    viewerId?: string;
  }) => ({
    queryKey: ["following-info", userId, viewerId],
    queryFn: () =>
      getUserFollowingInfoWithClient(userClient)({ userId, viewerId }),
  }),
  follow: ({
    followerId,
    followeeId,
  }: {
    followerId: string;
    followeeId: string;
  }) => ({
    queryKey: ["follow", followerId, followeeId],
    queryFn: () =>
      followUserWithClient(userClient)({
        followerId,
        followeeId,
      }),
  }),
  unfollow: ({
    followerId,
    followeeId,
  }: {
    followerId: string;
    followeeId: string;
  }) => ({
    queryKey: ["unfollow", followerId, followeeId],
    queryFn: () =>
      unfollowUserWithClient(userClient)({
        followerId,
        followeeId,
      }),
  }),
  listFollowers: ({
    userId,
    pageSize = 100,
    pageToken,
  }: {
    userId: string;
    pageSize?: number;
    pageToken?: string;
  }) => ({
    queryKey: ["list-followers", userId, pageSize, pageToken],
    queryFn: () =>
      listUserFollowersWithClient(userClient)({
        userId,
        pageSize,
        pageToken,
      }),
  }),
  listFollowing: ({
    userId,
    pageSize = 100,
    pageToken,
  }: {
    userId: string;
    pageSize?: number;
    pageToken?: string;
  }) => ({
    queryKey: ["list-following", userId, pageSize, pageToken],
    queryFn: () =>
      listUserFollowingWithClient(userClient)({
        userId,
        pageSize,
        pageToken,
      }),
  }),
});
